import axios from "axios";
import { setAlert } from "./alert";
import { setErrorsList } from "./errors";
import { logout } from "./auth";
import { removeErrors } from "reducers/errors";

import {
  loadingSourcesList,
  sourceSearchParametersUpdate,
  sourceListUpdated,
  resetSource,
  sourceError,
  loadingOnSourceSubmit,
  sourceCreated,
  sourceUpdated,
  sourceDetailsById,
  sourceDeleted,
  sourceStateList,
} from "reducers/sourceReducer";

export const getSourcesList = (sourceParams) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    const query = sourceParams.query ? sourceParams.query : "";
    sourceParams.query = query;
    config.params = sourceParams;

    dispatch(loadingSourcesList());
    const res = await axios.get("/api/admin/sources/list", config);

    dispatch(sourceSearchParametersUpdate(sourceParams));

    dispatch(sourceListUpdated(res.data.response[0]));
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          sourceError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const getSourceById = (source_id) => async (dispatch) => {
  dispatch(removeErrors());
  dispatch(loadingOnSourceSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(`/api/admin/sources/${source_id}`, config);

    dispatch(sourceDetailsById(res.data.response));
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    console.log(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          sourceError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const getCredentialsList = () => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    const res = await axios.get("/api/admin/sources/credentials-list", config);

    return res.data ? res.data.response : { status: false };
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          sourceError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const createSource = (formData, navigate) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    dispatch(loadingOnSourceSubmit());

    const res = await axios.post("/api/admin/sources", formData, config);

    if (res.data.status === true) {
      dispatch(sourceCreated(res.data.response));
      dispatch(setAlert("Source Created.", "success"));
      navigate(`/admin/sources`);

      return res.data;
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch(sourceError());
        dispatch(setAlert(res.data.message, "danger"));

        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          sourceError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const updateSource =
  (formData, navigate, source_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const res = await axios.put(
        `/api/admin/sources/${source_id}/edit`,
        formData,
        config
      );

      if (res.data.status === true) {
        await dispatch(sourceUpdated(res.data.response));
        dispatch(setAlert(res.data.message, "success"));
        return res.data ? res.data : { status: false };
      } else {
        const errors = res.data.errors;
        dispatch(setAlert(res.data?.message, "danger"));

        if (errors.length) {
          dispatch(sourceError());
          dispatch(setErrors(errors));
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch(
            sourceError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

export const deleteSource = (source_id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await axios.delete(`/api/admin/sources/${source_id}`, config);

    dispatch(sourceDeleted(source_id));
    dispatch(setAlert("Source deleted", "success"));
  } catch (err) {
    console.log(err);
    err.response &&
      dispatch(
        sourceError({
          msg: err.response.statusText,
          status: err.response.status,
        })
      );
  }
};

// reset errors
export const removeSourceErrors = () => async (dispatch) => {
  dispatch(removeErrors());
};

// Dispatch Reset store
export const resetComponentStore = () => async (dispatch) => {
  await dispatch(resetSource());
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch(sourceError());
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

export const cancelSave = (navigate) => async (dispatch) => {
  dispatch(removeErrors());
  navigate("/admin/sources");
};

export const getStatesList = () => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    var res = await axios.get(`/api/common/state/list`, config);

    if (res.data.status === true) {
      await dispatch(sourceStateList(res.data.response));
    }
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    console.log(err);
  }
};
